import styled, { css } from 'styled-components';
export const Tooltip = styled.div(({ $withPadding, $fluid }) => css `
    position: relative;
    z-index: 1;
    width: auto;
    max-width: 250px;
    background-color: var(--bg-primary-invert);
    border-radius: var(--radius-brand);
    color: var(--text-primary-invert);
    font-size: var(--font-size-300);
    font-weight: var(--font-weight-medium);
    line-height: var(--font-line-height-300);
    letter-spacing: var(--font-letter-spacing-loose);
    text-transform: none;
    white-space: normal;
    text-align: left;

    ${$withPadding &&
    css `
      padding: var(--space-100) var(--space-200);
    `}

    ${$fluid &&
    css `
      width: auto;
    `}
  `);
//# sourceMappingURL=styled.js.map